<template>
  <v-app class="monitor-app">
    <v-app-bar app dark color="#0f172a" height="70" flat>
      <v-btn icon @click="$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>


      <v-spacer />

    </v-app-bar>

    <v-main class="control-room">
      <div class="room-bg">
        <div class="wall-panel"></div>
        <div class="ceiling-light"></div>
        <div class="city-glow"></div>
      </div>

      <div class="smartboard-wrapper">
        <div class="smartboard-tv">
          <div class="board-header">
            <div class="board-title">MONITORING CCTV BONDOWOSO</div>
            <div class="board-time">
              {{ currentTime }}
            </div>
          </div>

          <div class="grid-container">
            <div class="camera-grid">
              <div
                v-for="cam in cctvItems"
                :key="cam.id"
                class="camera-box"
                @click="openCamera(cam)"
              >
                <img
                  :src="
                    failedCameras.includes(cam.id)
                      ? offlinePlaceholder
                      : getGridSnapshot(cam)
                  "
                  class="camera-feed"
                  @error="handleImageError(cam.id)"
                />

                <div class="camera-overlay">
                  <div class="camera-name">
                    {{ cam.deskripsi }}
                  </div>

                  <div
                    :class="[
                      'camera-live',
                      failedCameras.includes(cam.id) ? 'status-offline' : '',
                    ]"
                  >
                    <span class="live-dot"></span>
                    {{ failedCameras.includes(cam.id) ? "OFFLINE" : "MONITOR" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card color="black">
        <v-toolbar dark color="black" flat>
          <v-toolbar-title>
            {{ selectedCamera.deskripsi }}
            <span style="color: #ef4444; font-size: 14px; margin-left: 10px"
              >• LIVE STREAM</span
            >
          </v-toolbar-title>

          <v-spacer />

          <v-btn color="red" dark @click="closeCamera"> Tutup </v-btn>
        </v-toolbar>

        <div class="fullscreen-wrapper">
          <img
            v-if="dialog && selectedCamera.id"
            :src="getFullscreenLive(selectedCamera)"
            class="fullscreen-camera"
            @error="handleFullscreenError"
          />
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import { getLayananPublik } from "@/api/androidInitApi";

export default {
  name: "CCTVMonitor",

  data() {
    return {
      items: [],
      dialog: false,
      selectedCamera: {},
      gridTimestamp: Date.now(),
      currentTime: "",
      gridTimer: null,
      clockTimer: null,
      failedCameras: [],
      offlinePlaceholder:
        "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 24 24' fill='none' stroke='%23374151' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><rect x='2' y='3' width='20' height='14' rx='2' ry='2'></rect><line x='2' y='10' ...></line><path d='m8 6 8 8'></path></svg>",
    };
  },

  computed: {
    cctvItems() {
      return this.items.filter(
        (item) => item.nama_layanan && item.nama_layanan.toLowerCase().includes("cctv")
      );
    },
  },

  mounted() {
    this.fetchData();

    this.gridTimer = setInterval(() => {
      this.gridTimestamp = Date.now();
    }, 5000);

    this.updateClock();
    this.clockTimer = setInterval(() => {
      this.updateClock();
    }, 1000);
  },

  beforeDestroy() {
    clearInterval(this.gridTimer);
    clearInterval(this.clockTimer);
  },

  methods: {
    updateClock() {
      const now = new Date();
      this.currentTime =
        now.toLocaleDateString("id-ID") + " " + now.toLocaleTimeString("id-ID");
    },

    async fetchData() {
      try {
        this.items = (await getLayananPublik()) || [];
        this.failedCameras = [];
      } catch (err) {
        console.error("Gagal mengambil data:", err);
      }
    },

    getMidParam(linkLayanan) {
      if (!linkLayanan) return null;
      try {
        const urlObj = new URL(linkLayanan);
        return urlObj.searchParams.get("mid");
      } catch (e) {
        const match = linkLayanan.match(/[?&]mid=(\d+)/);
        return match ? match[1] : null;
      }
    },

    getGridSnapshot(item) {
      const mid = this.getMidParam(item.link_layanan);
      if (mid) {
        return `https://cctv.bondowosokab.go.id/cgi-bin/nph-zms?mode=single&scale=40&monitor=${mid}&user=view&pass=K0minfo&t=${this.gridTimestamp}`;
      }
      return item.full_url || item.link_layanan || "";
    },

    getFullscreenLive(item) {
      const mid = this.getMidParam(item.link_layanan);
      if (mid) {
        return `https://cctv.bondowosokab.go.id/cgi-bin/nph-zms?mode=jpeg&scale=100&maxfps=15&monitor=${mid}&user=view&pass=K0minfo&t=${Date.now()}`;
      }
      return item.full_url || item.link_layanan || "";
    },

    handleImageError(id) {
      if (!this.failedCameras.includes(id)) {
        this.failedCameras.push(id);
      }
    },

    handleFullscreenError() {
      console.log("Kamera fullscreen gagal dimuat.");
    },

    openCamera(cam) {
      this.selectedCamera = cam;
      this.dialog = true;
    },

    closeCamera() {
      this.dialog = false;
      this.selectedCamera = {};
    },
  },
};
</script>

<style scoped>
.monitor-app {
  background: #020617;
  overflow-x: hidden;
}

.control-room {
  min-height: 100vh;
  position: relative;
}

.room-bg {
  position: fixed;
  inset: 0;
  overflow: hidden;
  z-index: 0;

  background: radial-gradient(circle at 50% 0%, rgba(0, 255, 200, 0.12), transparent 35%),
    linear-gradient(to bottom, #0f172a 0%, #020617 40%, #000814 100%);
}

.room-bg::before {
  content: "";
  position: absolute;
  inset: 0;

  background-image: linear-gradient(rgba(0, 255, 200, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 255, 200, 0.04) 1px, transparent 1px);

  background-size: 80px 80px;
  opacity: 0.35;
}

.room-bg::after {
  content: "";
  position: absolute;
  top: -150px;
  left: 50%;
  transform: translateX(-50%);
  width: 1200px;
  height: 500px;

  background: radial-gradient(ellipse, rgba(0, 255, 180, 0.18), transparent 70%);

  filter: blur(80px);
}

.control-room::before {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;

  background: repeating-linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.02),
    rgba(255, 255, 255, 0.02) 1px,
    transparent 2px,
    transparent 4px
  );

  z-index: 1;
}

.control-room::after {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;

  background: radial-gradient(
    ellipse at center,
    transparent 50%,
    rgba(0, 0, 0, 0.6) 100%
  );

  z-index: 1;
}

.smartboard-wrapper {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 70px);
  padding: 20px;
}

.smartboard-tv {
  width: 95%;
  height: 85vh;

  background: #000;
  border-radius: 24px;

  border: 2px solid rgba(0, 255, 200, 0.25);

  box-shadow: 0 0 20px rgba(0, 255, 180, 0.15), 0 0 60px rgba(0, 255, 180, 0.08),
    0 30px 80px rgba(0, 0, 0, 0.8);

  overflow: hidden;
  display: flex;
  flex-direction: column;

  backdrop-filter: blur(10px);
}

.smartboard-wrapper::after {
  content: "";
  position: absolute;

  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  width: 90%;
  height: 120px;

  background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.85), transparent 80%);

  z-index: -1;
}

.board-header {
  height: 60px;
  background: linear-gradient(to right, #111827, #1f2937);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #374151;
  flex-shrink: 0;
}

.board-title {
  color: white;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 2px;
}

.board-time {
  color: #cfa22d;
  font-weight: 700;
  font-size: 15px;
}

.grid-container {
  flex-grow: 1;
  overflow-y: auto;
  background: #000;
  padding: 12px;
}

.grid-container::-webkit-scrollbar {
  width: 8px;
}
.grid-container::-webkit-scrollbar-track {
  background: #000;
}
.grid-container::-webkit-scrollbar-thumb {
  background: #1f2937;
  border-radius: 4px;
}

.camera-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

@media (max-width: 1440px) {
  .camera-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 960px) {
  .camera-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.camera-box {
  position: relative;
  aspect-ratio: 16 / 9;
  background: #0b0f19;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #1f2937;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.camera-box:hover {
  transform: scale(1.03);
  border-color: #018c74;
  z-index: 5;
}

.camera-feed {
  width: 100%;
  height: 100%;
  object-fit: fill;
  background: #000;
}

.camera-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.3) 0%,
    transparent 50%,
    rgba(0, 0, 0, 0.85) 100%
  );
  pointer-events: none;
}

.camera-name {
  color: white;
  font-size: 12px;
  font-weight: 700;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.camera-live {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #018c74;
  font-size: 10px;
  font-weight: 800;
  background: rgba(0, 0, 0, 0.65);
  padding: 2px 6px;
  border-radius: 4px;
}

.camera-live.status-offline {
  color: #64748b;
}
.camera-live.status-offline .live-dot {
  background: #475569;
  animation: none;
}

.live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(90deg, #016b62 0%, #018c74 45%, #8bcdc6 100%);
}

.fullscreen-wrapper {
  width: 100%;
  height: calc(100vh - 64px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
}

.fullscreen-camera {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.clock {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}
</style>
